module.exports = __webpack_public_path__ + "img/LOGO-6.fe50a09b.png";